<mat-dialog-content>
  <form
    [formGroup]="form"
    (ngSubmit)="
      form.valid && form.get('responseTypeId').value
        ? save(form.value)
        : errorMessage()"
  >
    <div class="display-flex flex-column" style="display: flex; width: 100%">
      <div class="col-12">

        <mat-form-field class="my-1">
          <mat-label>Pregunta</mat-label>
          <textarea
            autocomplete="off"
            formControlName="question"
            matInput
            #nombre
            rows="3"
            maxlength="250"
            placeholder="Pregunta"
            required
          ></textarea>
          <mat-hint>{{ nombre.value.length }}/250</mat-hint>
        </mat-form-field>

        <!-- Response Type -->
        <combos
          class="my-1"
          [configuration]="combosConfigResType"
          [reloadCombo]="reloadComboResType"
          [required]="true"
          [filter]="true"
          (changeOption)="ValueResType($event)"
        >
        </combos>
      </div>

      <div class="col-12 text-center">
        <button
          style="width: 70%; margin: 15px 0 10px 0"
          color="primary"
          class="button-save mat-elevation-z5"
          mat-raised-button
          type="submit"
        >
          Aceptar
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>
